import { createRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import ReCAPTCHA from 'react-google-recaptcha-enterprise';

export type QuipliReCAPTCHARef = {
  getToken: () => string | null;
  validate: () => { isValid: boolean; error: string };
} | null;

type QuipliReCAPTCHAProps = {
  sitekey?: string;
};

export const QuipliReCAPTCHA = forwardRef<QuipliReCAPTCHARef, QuipliReCAPTCHAProps>(
  ({ sitekey }: QuipliReCAPTCHAProps, ref) => {
    const { getConfiguration } = useAPI();
    const [key, setKey] = useState<string | undefined>(sitekey);

    const recaptchaRef = createRef<ReCAPTCHA>();

    useEffect(() => {
      if (sitekey !== undefined) {
        return;
      }

      getConfiguration('CONF_GOOGLE_RECAPTCHA_SITE_KEY').then((config) => {
        setKey(config?.value);
      });
    }, []);

    useImperativeHandle(
      ref,
      () => {
        return {
          getToken() {
            return recaptchaRef.current?.getValue() ?? null;
          },
          validate() {
            const token = recaptchaRef.current?.getValue();
            const isValid = !!token;
            return {
              isValid,
              error: isValid ? '' : 'Please complete the reCAPTCHA verification.',
            };
          },
        };
      },
      [],
    );

    return key?.length ? (
      <div className="w-full flex justify-center">
        <ReCAPTCHA ref={recaptchaRef} sitekey={key} />
      </div>
    ) : null;
  },
);
